
import VHeader from '~/components/VHeader'
import VFooter from '~/components/VFooter'
export default {
  name: 'Default',
  components: { VFooter, VHeader }
}
